import { HomeSearchBarInput } from "../Home/HomeSearchBar";
import { styled } from "@mui/material/styles";
import { MOBILE_SCREEN_SIZE } from "../../../AppNavigation/constants";

export const HomePageContainer = styled("div")({
  width: "100%",
});

export const BrandstoreLandingDescription = styled("p")(({ theme }) => ({
  fontSize: 20,
  fontWeight: 500,
  marginBottom: 40,
  marginTop: 0,
  [theme.breakpoints.down("md")]: {
    maxWidth: 662,
    marginLeft: "auto",
    marginRight: "auto",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: 14,
    marginBottom: 20,
  },
}));

export const BrandHeaderContainer = styled("div")({
  textAlign: "center",
  padding: "40px 0 30px 0",
  width: "100%",
  [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
    padding: "20px 0",
  },
  ".brand_landing_name": {
    fontSize: 20,
    fontWeight: 500,
    marginBottom: 10,
    [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
      fontSize: 14,
    },
  },
  ".brand_landing_title": {
    fontSize: 40,
    fontWeight: 700,
    marginBottom: 10,
    [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
      fontSize: 22,
    },
  },
});

export const SearchBar = styled(HomeSearchBarInput)({
  textAlign: "left",
  marginTop: 0,
  paddingTop: 0,
});
